import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import UpdateUserSurvey from "../mutations/UpdateUserSurvey";
import Spinner from "./Spinner";
import CurrentUserData from "../queries/CurrentUserData";
//css
import { Table, Button, Card, CardHeader, CardBody, Modal } from "reactstrap";

const PersonalSurveyList = () => {
  const navigate = useNavigate();
  const {loading, error, data} = useQuery( CurrentUserData )
  const [showModal, setShowModal] = useState(false)
  const [surveyVariables, setSurveyVariables] = useState(null)

  const [updateUserSurveyMutation] = useMutation(UpdateUserSurvey);
  
  if(loading) return <Spinner />
  if(error) {
    console.log("error:")
    console.log(error)
    return <p>Something Went Wrong...</p>
  }

  const {currentUserData} = data

  const handleMutation = (variables) => {
    updateUserSurveyMutation({
      variables,
      refetchQueries: [{ query: CurrentUserData }],
    })
      .then((result) => {
        console.log("Mutation result: ", result);
      })
      .catch((error) => {
        console.log("Mutation error: ", error);
      });
  };

  function displayDate(date) {
    if (date == null) {
      return;
    }

    // parse the time stored
    const parsedDate = JSON.parse(date);
    // convert the string to a date
    const actualDate = new Date(parsedDate);
    // check if time is anythng other than 1... time is # of seconds since Jan 1 1970, no reason for it to be 1 but it will be 1 if failing
    if (actualDate.getTime() === 1) {
      return;
    }

    // reached here because it has been completed and has valid date
    return `${actualDate.getUTCMonth() + 1}/${actualDate.getUTCDate()}/${actualDate.getFullYear()}`;
  }

  function displayProblems(problems) {
    const length = typeof problems == "undefined" || problems == null ? 0 : problems.length;
    return `Reported ${length} issues.`;
  }

  function onSubmit(survey) {
    const dateToStore = new Date();
    const newVariables = {
      surveyId: survey.id,
      completed_date: JSON.stringify(dateToStore),
    };

    setSurveyVariables(newVariables)
    setShowModal(true)
  }

  function handleConfirm(choice) {
    setShowModal(false)

    if(choice) {
      handleMutation(surveyVariables);
    }

    setSurveyVariables(null)
  }

  return (
    <>
      <Card className='shadow-lg'>
        <CardHeader>
          <h3 className='mb-0'>Surveys</h3>
        </CardHeader>
        <CardBody className="p-0">
          <Table responsive striped>
            <thead className='table-dark'>
              <tr>
                <th scope='col'>Survey</th>
                <th scope='col'>Section 1</th>
                <th scope='col'>Section 2</th>
                <th scope='col'>Section 3</th>
                <th scope='col'>Completed</th>
                <th scope='col'>Options</th>
              </tr>
            </thead>
            <tbody>
              {currentUserData.surveys?.map((survey, sIndex) => {
                const surveyOneDisplay = displayDate(currentUserData.section_1_completed_date);
                const surveyTwoDisplay = displayProblems(survey.problems);
                const surveyThreeDisplay = displayDate(survey.section_3_completed_date);
                const completedDate = displayDate(survey.completed_date);

                return (
                  <tr key={`survey_id_${sIndex}`}>
                    <td className='align-middle' style={{maxWidth: "50%", whiteSpace: "normal"}}><span className="text-break">{survey.title}</span></td>
                    <td className='align-middle'>{surveyOneDisplay != null ? surveyOneDisplay : "Incomplete"}</td>
                    <td className='align-middle'>{surveyTwoDisplay}</td>
                    <td className='align-middle'>{surveyThreeDisplay != null ? surveyThreeDisplay : "Incomplete"}</td>
                    <td className='align-middle'>
                      {completedDate}
                    </td>
                    <td className='align-middle'>
                      <div className='d-inline-flex justify-content-between align-items-center w-100'>
                        {(typeof completedDate === 'undefined' || completedDate === null) &&
                          <Button 
                            onClick={() => { navigate(`/surveys/${survey.id}`) }}
                            color="primary"
                            size="sm"
                          >
                            View
                          </Button>
                        }
                        {typeof surveyOneDisplay !== "undefined" && surveyOneDisplay !== null && typeof surveyThreeDisplay !== "undefined" && surveyThreeDisplay !== null &&
                        <Button 
                          onClick={(e) => {
                            e.preventDefault();
                            onSubmit(survey);
                          }}
                          color="primary"
                          disabled={completedDate != null ? true : false}
                          size="sm"
                        >
                          {typeof completedDate === 'undefined' || completedDate === null ? "Submit" : "Submitted"}
                        </Button>
                        }
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
      <Modal
        className="modal-dialog-centered"
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Modal title
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">You have answered all required fields in Section 1 and 3. Are you ready to submit this survey? Once submitted no more changes can be made. You can submit at any time by clicking submit on the survey list or by clicking save again on one of the survey sections.</div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => handleConfirm(false)}>Cancel</Button>
          <Button color="primary" onClick={() => handleConfirm(true)}>Submit</Button>
        </div>
      </Modal>
    </>
  );
};

export default PersonalSurveyList;
